import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { useParams } from "react-router-dom";
import { getAllDetails } from "../../service/ProductService";
import { GET_USER_INVOICE_LIST } from "../../config/ApiConstant";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import {
  clientChargeInvoiceStatusDropdown,
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { Card } from "primereact/card";
import { userInvoiceListColumn } from "../../appconfig/DatatableSetting";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { Badge } from "primereact/badge";
import {
  dateTemplate,
  globalFieldTemplate,
} from "../../appconfig/TemplateFieldSetting";
import { Dialog } from "primereact/dialog";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Link } from "react-router-dom";
import {
  formatDate,
  formatMonth,
  formatMonthYear,
} from "../../appconfig/AppHelper";
import { Tooltip } from "primereact/tooltip";

const UserInvoicePlatformCharge = () => {
  document.title = "Client Charge Invoice | Nexawage Payroll";

  // get id from param
  const { id } = useParams();
  const user_id = id ? atob(id) : null;

  //   toast ref
  const toast = useRef<any>(null);

  // loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  //   filter obj
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // invoice list obj
  const [userInvoiceList, setUserInvoiceList] = useState<any>([]);

  //   client invoices list
  const [clientInvoicesList, setClientInvoicesList] = useState<any>([]);

  //   company name in row obj
  const [selectedClients, setSelectedClients] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);

  //   row expand state
  const [expandedRows, setExpandedRows] = useState<any>(undefined);

  //   invoice status
  const [invoiceStatus, setInvoiceStatus] = useState<any>(null);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    status: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    invoice_created_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    invoice_pay_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  //   user id to send in api call
  let userIdToSend: any = null;
  if (userRole === "Admin") {
    userIdToSend = user_id;
  } else if (userRole === "User") {
    userIdToSend = userData?.id;
  }

  //   useEffect to get user invoice list
  useEffect(() => {
    getUserInvoicList();
  }, []);

  //   get user invoice list api call
  const getUserInvoicList = async () => {
    try {
      const response = await getAllDetails(
        `${GET_USER_INVOICE_LIST}?user_id=${userIdToSend}`
      );

      if (response) {
        // normalise date to convert into data object instead of string
        const normalise = response?.map((item: any) => ({
          ...item,
          invoice_created_date: item?.invoice_created_date
            ? new Date(item?.invoice_created_date.substring(0, 10) + "T00:00:00")
            : null,
          // convert paid date from string to date obj for filter
          invoice_pay_date: item?.invoice_pay_date
            ? new Date(item?.invoice_pay_date.substring(0, 10) + "T00:00:00")
            : null,
        }));
        setUserInvoiceList(normalise);

        // client invoices
        const allClientInvoices = response?.map(
          (item: any) => item.client_invoices || []
        );

        setClientInvoicesList(allClientInvoices);

        setPageLoad(true);
      } else {
        setUserInvoiceList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      setPageLoad(true);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    }
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left ">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={globalFilter || ""}
          onInput={(e) => setGlobalFilter(e.currentTarget.value)}
          placeholder="Search..."
        />
      </span>
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <div className="payrollreport-template">
      {userRole !== "Employee" && (
        <>
          <Button
            icon="pi pi-filter-slash"
            label="Clear"
            onClick={() => clearAll()}
            className="mr-2 p-button-outlined common-p-outline-button"
          />
        </>
      )}
    </div>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.invoice_url) {
      window.open(rowData?.invoice_url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // pdf view template
  const pdfViewTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="Download PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  // invoice status template
  const invoiceStatusTemplate = (rowData: any) => {
    let statusClass: any =
      rowData?.status === "paid"
        ? "success"
        : rowData?.status === "failed"
        ? "danger"
        : rowData?.status === "created"
        ? "warning"
        : null;

    let statusValue: any =
      rowData?.status === "paid"
        ? "Paid"
        : rowData?.status === "created"
        ? "Created"
        : rowData?.status === "failed"
        ? "Failed"
        : null;
    return (
      <Badge
        severity={statusClass}
        value={statusValue}
        style={{ width: "fit-content" }}
      ></Badge>
    );
  };

  // companyName template
  // const companyNameTemplate = (rowData: any) => {
  //   const companyName = rowData?.client?.company_name;
  //   return <span>{companyName}</span>;
  // };

  const companyNameTemplate = (rowData: any) => {
    const companyNames: string[] = rowData?.client?.company_name
      ? [rowData.client.company_name]
      : rowData?.client_invoices
          ?.map((item: any) => item?.client?.company_name)
          ?.filter(Boolean) || [];

    if (companyNames.length === 0) return <span>-</span>;

    const firstName = companyNames[0];
    const hasMore = companyNames?.length > 1;
    const tooltipText = companyNames.join(", ");
    const tooltipId = `company-tooltip-${rowData.id}`;

    return (
      <>
        {hasMore && (
          <Tooltip
            style={{ maxWidth: "200px" }}
            target={`#${tooltipId}`}
            content={tooltipText}
            className="company-tooltip"
            position={"top"}
          />
        )}

        <span
          id={tooltipId}
          style={{ cursor: hasMore ? "pointer" : "default" }}
        >
          {firstName}
          {hasMore && " ..."}
        </span>
      </>
    );
  };

  // invoice no template

  //   allow row expansion
  const allowExpansion = (rowData: any) => {
    return rowData?.client_invoices?.length > 0;
  };

  // client detail template
  const clientDetailTemplate = (rowData: any) => {
    return (
      <Link
        style={{ textDecoration: "underline", color: "blue" }}
        to={`/clients/${btoa(rowData?.id)}`}
      >
        {rowData.unique_id}
      </Link>
    );
  };

  //   row expansion template
  const rowExpansionTemplate = (data: any) => {
    const clientInfo = data?.client_invoices?.map((c: any) => c?.client) || [];

    return (
      <div className="p-3 mt-3 mb-2">
        <h5 className="pb-2">
          Clients Who have Paid their Platform charge for (
          {` ${formatMonthYear(data?.invoice_pay_date)} `})
        </h5>

        <DataTable value={clientInfo} emptyMessage="No Client Found">
          <Column
            field="unique_id"
            header="Client ID"
            body={clientDetailTemplate}
          />
          <Column field="company_name" header="Client Name" />
          <Column field="email" header="Email" />
          <Column field="phone" header="Phone" />
        </DataTable>
      </div>
    );
  };

  // date filter template
  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
        dateFormat="dd/mm/yy"
        placeholder="Select Date"
        showIcon
      />
    );
  };

  // invoice status filter template
  const invoiceStatusFilterTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={invoiceStatus}
        onChange={(e: any) => {
          setInvoiceStatus(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={clientChargeInvoiceStatusDropdown}
        optionLabel="name"
        placeholder="Status"
        className="order-drp"
      ></Dropdown>
    );
  };

  return (
    <>
      <AppBreadcrumb
        pageName="List"
        pageTitle="Client Charge Invoice"
        currentMenu="Invoice"
        goToPage={true}
      />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar
              className="gap-3"
              left={leftToolbarTemplate}
              right={rightToolbarTemplate}
            />
            {pageLoad ? (
              <DataTable
                value={userInvoiceList}
                showGridlines
                dataKey="id"
                responsiveLayout={"scroll"}
                stripedRows
                //   globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={userInvoiceList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Invoice List"}
                emptyMessage="No Invoice Found"
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                removableSort
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
              >
                {userInvoiceListColumn.map((col, i) => {
                  if (col.field === "invoice_url") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={pdfViewTemplate}
                      />
                    );
                  } else if (col.field === "invoice_no") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={globalFieldTemplate}
                      />
                    );
                  } else if (col.field === "company_name") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={companyNameTemplate}
                      />
                    );
                  } else if (col.field === "status") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={invoiceStatusTemplate}
                        filter
                        filterField="status"
                        filterElement={invoiceStatusFilterTemplate}
                      />
                    );
                  } else if (col.field === "invoice_created_date") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dateTemplate}
                        dataType="date"
                        filter
                        sortable
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "invoice_pay_date") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dateTemplate}
                        dataType="date"
                        filter
                        sortable
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        expander={allowExpansion}
                        style={{ width: "2rem" }}
                      />
                    );
                  } else {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {userInvoiceListColumn.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={SkeletonbodyTemplate}
                  />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

export default UserInvoicePlatformCharge;
